import React, { forwardRef } from "react";
import { Row, Col, Layout } from "antd";
import Dropzone from "../util/Dropzone";
import RestrictedComponent from "../util/RestrictedComponent";
import { addAsset } from "../../features/asset/assetSlice";
import Assets from "../../features/assets";
const Documents = forwardRef((props, ref) => {
  const { branch_id, resource, action, entityId, fromCrm } = props;

  return (
    <div style={{ display: "flex", flexDirection: "column" }} ref={ref}>
      <Layout
        style={{ background: "transparent", height: "100%", overflow: "auto" }}
      >
        <Row>
          <RestrictedComponent resource={resource} action={action} comp={null}>
            <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24}>
              <Dropzone
                addAsset={addAsset}
                branch_id={branch_id}
                resource={resource}
                entityId={entityId}
              />
            </Col>
          </RestrictedComponent>
          <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24}>
            <Assets resource={resource} entityId={entityId} fromCrm={fromCrm} />
          </Col>
        </Row>
      </Layout>
    </div>
  );
});

export default Documents;

// <Surface style={{ minHeight: "334px" }}>
//   <FormHeader
//     title={<FormattedMessage id="app.titles.uploadedDocs" />}
//   />
//   <Table
//     bordered
//     rowKey={(record) => record.name}
//     columns={columns}
//     dataSource={files}
//   />
// </Surface>
